import axios from './base';

const sendOtp = body => axios.post('/api/v1/totp/sms', body);

const verifyOtp = body => axios.post('/api/v1/totp/sms/verify', body);

export { sendOtp, verifyOtp };
